import { CategoryLookupState } from '@/redux';

export function buildCategoryPath(path: CategoryLookupState[]): string {
  return path.map((x) => x.name).join(' / ');
}
